// Keep in sync with backend/src/const/user.ts DISTRICT_PERMISSIONS.
const districtPermissions = {
  SCHOOL_DISTRICT: 'school-district',
  PUBLISHER: 'publisher',
  DATA_OPS: 'data-ops',
  ADMIN_LOGIN_VIA_LTI: 'admin-login-via-lti',
  GRID_EDIT: 'grid-edit',
  AI_QUIZ: 'ai-quiz',
  VIDEO_QUIZ: 'video-quiz',
  TTS_LLM: 'tts-llm',
  AUTO_ASSIGN: 'auto-assign',
  INSTANT_LESSON_PACKAGE: 'instant-lesson-package',
  CONTENT_CLARIFIER: 'content-clarifier',
  ENABLE_SEMANTIC_SEARCH: 'enable-semantic-search',
  ENFORCE_SEB_SERVICE: 'enforce-seb-service',
  ENABLE_DISTRICT_CONTENT_FILTER: 'enable-district-content-filter',
  ENABLE_PLAN_INTERVENTIONS: 'enable-plan-interventions',
  GEN_AI: 'gen-ai',
  AI_SUMMARY: 'ai-summary',
  BULK_CONTENT_CONVERTER: 'bulk-content-converter',
  BULK_MOVE_CONTENT_TO_DISTRICT: 'bulk-move-content-to-district',
  CURRICULUM_IMPORT: 'curriculum-import',
  ENABLE_PLAYLIST: 'enable-playlist',
  ENABLE_PEARY_CHAT: 'enable-peary-chat',
  DISABLE_PEARY_CHAT: 'disable-peary-chat',
  ILP_BUTTON_BLACKLISTED: 'ilp-button-blacklisted',
  ALLOW_AUTO_COMPLETE: 'allow-auto-complete',
  PROFILE_REPORTS: 'profile-reports',
  SURVEY_REPORTS: 'survey-reports',
  MFA_ENABLED: 'mfa-enabled',
  MFA_DISABLED: 'mfa-disabled',
  // GA blacklist flags (ASM-490): district-level opt-out for GA features.
  // User-level enable-* whitelist overrides these.
  DISABLE_PLAN_INTERVENTIONS: 'disable-plan-interventions',
  DISABLE_AI_SUMMARY: 'disable-ai-summary',
  DISABLE_PROFILE_REPORTS: 'disable-profile-reports',
  DISABLE_SURVEY_REPORTS: 'disable-survey-reports',
  DISABLE_SEMANTIC_SEARCH: 'disable-semantic-search',
  DISABLE_AUTO_COMPLETE: 'disable-auto-complete',
  DISABLE_DISTRICT_CONTENT_FILTER: 'disable-district-content-filter',
  DISABLE_GEN_AI: 'disable-gen-ai',
  DISABLE_CURRICULUM_IMPORT: 'disable-curriculum-import',
  AI_QUESTION_ASSISTANCE: 'ai-question-assistance',
  DISABLE_AI_QUESTION_ASSISTANCE: 'disable-ai-question-assistance',
  DISABLE_BULK_CONTENT_CONVERTER: 'disable-bulk-content-converter',
  TEST_METADATA_ASSISTANCE: 'test-metadata-assistance',
}

module.exports = districtPermissions
